import { ActionBase } from '../actions/action-base';
//
// Library
//
import * as Library from '../../../lib/core/library/index';
//
// Modell
//
import { ProtectionProduct } from '../../../lib/angular/model/protectionproduct/protection-product';
//
// Actions
//
import {
  PROTECTION_PRODUCTS_ACTION,
  ProtectionProductsActionLoad,
  ProtectionProductsActionSet,
  ProtectionProductsActionClear,
} from '../actions/protection-products.action';
//
// Reducer Interface
//
export interface IProtectionProducts {
  hasItems: boolean;
  items: ProtectionProduct;
}
//
// Initial State
//
export const PROTECTION_PRODUCTS_INITIAL_STATE: IProtectionProducts = {
  hasItems: false,
  items: null
};

/* tslint:disable:no-switch-case-fall-through */
export function ProtectionProductsReducer(
  state = PROTECTION_PRODUCTS_INITIAL_STATE,
  action: ActionBase
): IProtectionProducts {
  //
  // Switch on Action Type
  //
  switch (action.type) {
    case PROTECTION_PRODUCTS_ACTION.LOAD:
      return _onLoad(state, action as ProtectionProductsActionLoad);
    case PROTECTION_PRODUCTS_ACTION.SET:
      return _onSet(state, action as ProtectionProductsActionSet);
    case PROTECTION_PRODUCTS_ACTION.CLEAR:
      return _onClear(state, action as ProtectionProductsActionClear);
    default: {
      return state;
    }
  }
}
//
// General Functions
//
export function LoadProtectionProducts(state: IProtectionProducts) {
  return state;
}

//
// _onLoad()
//
function _onLoad(state: IProtectionProducts, action: ProtectionProductsActionLoad): IProtectionProducts {
  return Object.assign({}, state);
}

//
// _onSet()
//
function _onSet(state: IProtectionProducts, action: ProtectionProductsActionSet): IProtectionProducts {
  const _state = Object.assign({}, state, {
    items: action.payload,
    hasItems: Library.isArrayWithLength(action.payload)
  });
  //
  // Do Work...
  //
  return _state;
}

//
// _onClear()
//
function _onClear(state: IProtectionProducts, action: ProtectionProductsActionClear): IProtectionProducts {
  //
  // Do Work...
  //
  return Object.assign({}, state, { items: [] });
}

